import { useEffect, useRef } from "react";

/**
 * Adsterra's "atOptions" banner tag is a pair of <script> tags where the
 * second one (invoke.js) calls document.write() to inject its ad iframe at
 * that exact point in the document. That's safe on a classic server-rendered
 * page loaded top-to-bottom, but calling document.write() on OUR document
 * after React has already rendered would call an implicit document.open()
 * first, wiping the entire app.
 *
 * So each banner gets its own blank same-origin iframe, and the tag is
 * written into THAT iframe's fresh document instead — document.write() is
 * safe there, and the ad network's script behaves exactly as it expects to.
 */
export default function AdsterraBanner({ adKey, width, height }) {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`<!doctype html><html><head><style>html,body{margin:0;padding:0;overflow:hidden;}</style></head><body>
      <script>
        atOptions = {
          'key': '${adKey}',
          'format': 'iframe',
          'height': ${height},
          'width': ${width},
          'params': {}
        };
      <\/script>
      <script src="https://www.highrevenueformat.com/${adKey}/invoke.js"><\/script>
    </body></html>`);
    doc.close();
  }, [adKey, width, height]);

  return (
    <iframe
      ref={iframeRef}
      title="Advertisement"
      width={width}
      height={height}
      scrolling="no"
      style={{ border: 0, display: "block" }}
    />
  );
}
